import {BaseAuditableDto} from '../../../../../../shared/model/core/baseAuditableDto.model';
import {IWithPermissionModel} from '../../../../../common/permission/api/entity/iWithPermission.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {Moment} from 'moment';
import {DocumentSummaryModel} from '../../../../../document/common/api/model/documentSummary.model';
import {AccountSummary} from '../../../../../../shared/model/account/accountSummary.model';

export class PurchaseOrderSummaryModel extends BaseAuditableDto implements IWithPermissionModel {
    id: number;
    logKey: string;
    status: LovValueSummary;
    date: Moment;
    validUntil: Moment;
    document: DocumentSummaryModel;
    saleId: number;
    number: string;
    account: AccountSummary;
    totalPriceVatIncluded: number;
    totalPriceVatExcluded: number;
    totalVat: number;
    partnerId: number;
}
